import { render } from "./MfDate.vue?vue&type=template&id=b32a8390&scoped=true"
import script from "./MfDate.vue?vue&type=script&lang=js"
export * from "./MfDate.vue?vue&type=script&lang=js"

import "./MfDate.vue?vue&type=style&index=0&id=b32a8390&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b32a8390"]])

export default __exports__